const tooltips = {
  musor: 'Eseményekre lehet jegyet foglalni, illetve vásárolni ezen a felületen. Csak azok a helyszínek láthatóak a felhasználó számára, amelyeknek a szerepköre a felhasználóhoz van rendelve.',
  rendelesek: 'On-line és helyszíni foglalások és vásárlások lekérdezésére, karbantartására szolgáló felület, email újraküldés, fizetés, jegynyomtatás funkcióval.',
  lekerdezesek: 'Időszaki forgalom és nézőszám lekérdezése XLSX, illetve PDF formátumban.',
  emailsablonok: 'E-mail-ben küldött levelek sablon szövegeit lehet ezen a felületen rögzíteni, módosítani.',
  esemeny: 'Az Esemény kezdete (-tól) (-ig) mezőkben a maximálisan megadható időintervallum 1 év, és az időtartam 1 év abban az esetben is, ha a két mezőből csak az egyik kerül kitöltésre.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
